import VoucherCategoryService from '../../services/Voucher/voucher-category.service';

export const getVoucherCategory = async () => {
  let result = [];
  const res = await new VoucherCategoryService()
    .getAll({_size: 2147483647, status_eq: 1})
    .then(res => res);

  if (res?.data && Array.isArray(res?.data?.items)) {
    const newData = res?.data?.items?.reduce((items, item) => {
      items.push({
        title: item.title || '-',
        value: item.id,
      });
      return items;
    }, []);
    result = newData;
  }

  return result;
};
